import React from "react";
import "./mission.scss";

const Mission = () => {
  return (
    <section className="mission-section">
      <div className="__mw">
        <div className="mission-container">
          <div className="mission-label">
            <span className="dot"></span>
            OUR MISSION
          </div>

          <h2 className="mission-text">
            To redefine <span>financial success</span> through advanced
            analytics, AI-driven strategies, and real-time intelligence. We
            build adaptive solutions that <em>unlock alpha</em>, optimize risk,
            and empower investors to navigate complex markets with{" "}
            <span>unwavering confidence</span>.
          </h2>

          <div className="mission-footer">
            <div className="pillar">Innovation</div>
            <div className="divider"></div>
            <div className="pillar">Precision</div>
            <div className="divider"></div>
            <div className="pillar">Transparency</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Mission;
